import { css } from "@compiled/react";

import { ContactSalesNav } from "@/components/sales-navbar/index";
import { GlobalFooter } from "@/patterns/global-footer/src/index";
import GlobalNavigation from "@/patterns/global-nav/src/index";

import Hero from "./sections/hero";
import ResourceCards from "./sections/resource-cards";

const wrapperStyle = css({
    boxSizing: "border-box",
    clear: "both",
    display: "flex",
    flexDirection: "column"
});

export const EnterpriseContactThanksPageTemplate = () => {
    return (
        <div>
            <div css={wrapperStyle}>
                <div>
                    <GlobalNavigation
                        isShowTryNowLink={false}
                        tryNowLinkCtaButtonColor="light_grey"
                        productKey="enterpriseContactThanks"
                    />
                </div>
                <ContactSalesNav showContactSales={true} />
                <div>
                    <Hero />
                </div>
                <div>
                    <ResourceCards />
                </div>
            </div>
            <GlobalFooter />
        </div>
    );
};
